import * as React from "react";
import { TextField, InputAdornment, IconButton, Box } from "@mui/material";
import { styled } from "@mui/system";

import { ReactComponent as PlusIcon } from "../../static/svg/plus.svg";
import { ReactComponent as MinusIcon } from "../../static/svg/minus.svg";
import { useLocation } from "react-router-dom";

const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    fontSize: "1.2rem",
    fontFamily: "'IBM Plex Sans', sans-serif",
    paddingRight: 0,
    "& fieldset": {
      borderColor: theme.palette.mode === "dark" ? "#434D5B" : "#DAE2ED",
    },
    "&:hover fieldset": {
      borderColor: "#D3AC2B",
    },
  },
}));

export function QuantityControl({ value = 1, min = 1, max, onChange }) {
  const location = useLocation();
  const isCart = location.pathname.includes("cart");

  const safeValue = Number.isFinite(value) ? value : min;

  const decrement = () => {
    if (safeValue > min) {
      onChange(safeValue - 1);
    }
  };

  const increment = () => {
    if (max !== undefined && safeValue >= max) return;
    onChange(safeValue + 1);
  };

  return (
    <Box display="flex" alignItems="center" gap={2}>
      <IconButton onClick={decrement} disabled={safeValue <= min}>
        <MinusIcon className="w-4 h-4" />
      </IconButton>

      <Box
        minWidth={24}
        textAlign="center"
        fontSize={32}
        fontWeight={500}
        className={isCart ? "text-white" : "text-[#C3073F]"}
      >
        {safeValue}
      </Box>

      <IconButton
        onClick={increment}
        disabled={max !== undefined && safeValue >= max}
      >
        <PlusIcon className="w-4 h-4 " />
      </IconButton>
    </Box>
  );
}
